var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26.25,
    viewBox: "0 0 30 26.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-wallet",
    d: "M12.188-24.375a.939.939,0,0,1,.938.938.939.939,0,0,1-.937.938h-22.5a2.812,2.812,0,0,0-2.812,2.813V-2.812A2.813,2.813,0,0,0-10.312,0H10.313a2.813,2.813,0,0,0,2.813-2.812V-15.937a2.813,2.813,0,0,0-2.812-2.812H-8.437a.94.94,0,0,1-.937-.937.94.94,0,0,1,.938-.937h18.75A4.686,4.686,0,0,1,15-15.937V-2.812a4.686,4.686,0,0,1-4.687,4.688H-10.312A4.687,4.687,0,0,1-15-2.812V-19.687a4.688,4.688,0,0,1,4.688-4.687Zm-6.094,15A1.4,1.4,0,0,1,7.5-10.781,1.4,1.4,0,0,1,8.906-9.375,1.4,1.4,0,0,1,7.5-7.969,1.4,1.4,0,0,1,6.094-9.375Z",
    transform: "translate(15 24.375)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWallet);
export default __webpack_public_path__ + "static/media/ico-wallet.f5f1956e11bf2e27feacc29ca2fdad27.svg";
export { ForwardRef as ReactComponent };